import { render } from "./TwoFA.vue?vue&type=template&id=e5168f98"
import script from "./TwoFA.vue?vue&type=script&lang=js"
export * from "./TwoFA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/site/authorization/modal/TwoFA.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5168f98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5168f98', __exports__)) {
    api.reload('e5168f98', __exports__)
  }
  
  module.hot.accept("./TwoFA.vue?vue&type=template&id=e5168f98", () => {
    api.rerender('e5168f98', render)
  })

}


export default __exports__